function btnCollapse(objOpen, objClose) {
    objClose.classList.remove("active");
    objOpen.classList.add("active");
    objOpen.style.maxHeight = objOpen.scrollHeight + "px";
    objClose.style.maxHeight = null;
}
function resizeEvent() {
    let activeSection = document.querySelector(".results-section.active");
    activeSection.style.maxHeight = activeSection.scrollHeight + "px";
}
function accordion() {
    const accordionTitles = document.querySelectorAll(".accordionTitle");
    accordionTitles.forEach((accordionTitle) => {
        accordionTitle.addEventListener("click", () => {
            if (accordionTitle.classList.contains("is-open")) {
                accordionTitle.classList.remove("is-open");
            } else {
                const accordionTitlesWithIsOpen = document.querySelectorAll(".is-open");
                accordionTitlesWithIsOpen.forEach((accordionTitleWithIsOpen) => {
                    accordionTitleWithIsOpen.classList.remove("is-open");
                });
                accordionTitle.classList.add("is-open");
                let sectionThree = document.querySelector('.results-section--part-three');
                sectionThree.style.maxHeight = (sectionThree.scrollHeight * 3) + "px";
            }
        });
    });
}
export { btnCollapse, resizeEvent, accordion }